import BannerA from '../components/BannerA';
import Solution from '../components/Solution';

export default function StatusItem() {
    return (
        <>
            <BannerA />
            <Solution />
        </>
    );
}
